var productObject = [
  ["Gold", "Linear", "6", "classic", "yellow"],
  ["Gold", "Linear", "6", "classic", "white"],
  ["Gold", "Linear", "6", "classic", "rose"],
  ["Gold", "Linear", "6", "white", "yellow"],
  ["Gold", "Linear", "6", "white", "white"],
  ["Gold", "Linear", "6", "white", "rose"],
  ["Gold", "Linear", "6", "black", "yellow"],
  ["Gold", "Linear", "6", "black", "white"],
  ["Gold", "Linear", "6", "black", "rose"],
  ["Gold", "Linear", "8", "classic", "yellow"],
  ["Gold", "Linear", "8", "classic", "white"],
  ["Gold", "Linear", "8", "classic", "rose"],
  ["Gold", "Linear", "8", "white", "yellow"],
  ["Gold", "Linear", "8", "white", "white"],
  ["Gold", "Linear", "8", "white", "rose"],
  ["Gold", "Linear", "8", "black", "yellow"],
  ["Gold", "Linear", "8", "black", "white"],
  ["Gold", "Linear", "8", "black", "rose"],
  ["Gold", "Double Engraved", "6", "classic", "yellow"],
  ["Gold", "Double Engraved", "6", "classic", "white"],
  ["Gold", "Double Engraved", "6", "classic", "rose"],
  ["Gold", "Double Engraved", "6", "white", "yellow"],
  ["Gold", "Double Engraved", "6", "white", "white"],
  ["Gold", "Double Engraved", "6", "white", "rose"],
  ["Gold", "Double Engraved", "6", "black", "yellow"],
  ["Gold", "Double Engraved", "6", "black", "white"],
  ["Gold", "Double Engraved", "6", "black", "rose"],
  ["Gold", "Double Engraved", "8", "classic", "yellow"],
  ["Gold", "Double Engraved", "8", "classic", "white"],
  ["Gold", "Double Engraved", "8", "classic", "rose"],
  ["Gold", "Double Engraved", "8", "white", "yellow"],
  ["Gold", "Double Engraved", "8", "white", "white"],
  ["Gold", "Double Engraved", "8", "white", "rose"],
  ["Gold", "Double Engraved", "8", "black", "yellow"],
  ["Gold", "Double Engraved", "8", "black", "white"],
  ["Gold", "Double Engraved", "8", "black", "rose"],
  ["Gold", "Step Edge", "6", "classic", "yellow"],
  ["Gold", "Step Edge", "6", "classic", "white"],
  ["Gold", "Step Edge", "6", "classic", "rose"],
  ["Gold", "Step Edge", "6", "white", "yellow"],
  ["Gold", "Step Edge", "6", "white", "white"],
  ["Gold", "Step Edge", "6", "white", "rose"],
  ["Gold", "Step Edge", "6", "black", "yellow"],
  ["Gold", "Step Edge", "6", "black", "white"],
  ["Gold", "Step Edge", "6", "black", "rose"],
  ["Gold", "Step Edge", "8", "classic", "yellow"],
  ["Gold", "Step Edge", "8", "classic", "white"],
  ["Gold", "Step Edge", "8", "classic", "rose"],
  ["Gold", "Step Edge", "8", "white", "yellow"],
  ["Gold", "Step Edge", "8", "white", "white"],
  ["Gold", "Step Edge", "8", "white", "rose"],
  ["Gold", "Step Edge", "8", "black", "yellow"],
  ["Gold", "Step Edge", "8", "black", "white"],
  ["Gold", "Step Edge", "8", "black", "rose"],
  ["Gold", "Flat Milgrain", "6", "classic", "yellow"],
  ["Gold", "Flat Milgrain", "6", "classic", "white"],
  ["Gold", "Flat Milgrain", "6", "classic", "rose"],
  ["Gold", "Flat Milgrain", "6", "white", "yellow"],
  ["Gold", "Flat Milgrain", "6", "white", "white"],
  ["Gold", "Flat Milgrain", "6", "white", "rose"],
  ["Gold", "Flat Milgrain", "6", "black", "yellow"],
  ["Gold", "Flat Milgrain", "6", "black", "white"],
  ["Gold", "Flat Milgrain", "6", "black", "rose"],
  ["Gold", "Flat Milgrain", "8", "classic", "yellow"],
  ["Gold", "Flat Milgrain", "8", "classic", "white"],
  ["Gold", "Flat Milgrain", "8", "classic", "rose"],
  ["Gold", "Flat Milgrain", "8", "white", "yellow"],
  ["Gold", "Flat Milgrain", "8", "white", "white"],
  ["Gold", "Flat Milgrain", "8", "white", "rose"],
  ["Gold", "Flat Milgrain", "8", "black", "yellow"],
  ["Gold", "Flat Milgrain", "8", "black", "white"],
  ["Gold", "Flat Milgrain", "8", "black", "rose"],
  ["Gold", "Center Milgrain", "6", "classic", "yellow"],
  ["Gold", "Center Milgrain", "6", "classic", "white"],
  ["Gold", "Center Milgrain", "6", "classic", "rose"],
  ["Gold", "Center Milgrain", "6", "white", "yellow"],
  ["Gold", "Center Milgrain", "6", "white", "white"],
  ["Gold", "Center Milgrain", "6", "white", "rose"],
  ["Gold", "Center Milgrain", "6", "black", "yellow"],
  ["Gold", "Center Milgrain", "6", "black", "white"],
  ["Gold", "Center Milgrain", "6", "black", "rose"],
  ["Gold", "Center Milgrain", "8", "classic", "yellow"],
  ["Gold", "Center Milgrain", "8", "classic", "white"],
  ["Gold", "Center Milgrain", "8", "classic", "rose"],
  ["Gold", "Center Milgrain", "8", "white", "yellow"],
  ["Gold", "Center Milgrain", "8", "white", "white"],
  ["Gold", "Center Milgrain", "8", "white", "rose"],
  ["Gold", "Center Milgrain", "8", "black", "yellow"],
  ["Gold", "Center Milgrain", "8", "black", "white"],
  ["Gold", "Center Milgrain", "8", "black", "rose"],
  ["Gold", "Crystalline", "6", "classic", "yellow"],
  ["Gold", "Crystalline", "6", "classic", "white"],
  ["Gold", "Crystalline", "6", "classic", "rose"],
  ["Gold", "Crystalline", "6", "white", "yellow"],
  ["Gold", "Crystalline", "6", "white", "white"],
  ["Gold", "Crystalline", "6", "white", "rose"],
  ["Gold", "Crystalline", "6", "black", "yellow"],
  ["Gold", "Crystalline", "6", "black", "white"],
  ["Gold", "Crystalline", "6", "black", "rose"],
  ["Gold", "Crystalline", "8", "classic", "yellow"],
  ["Gold", "Crystalline", "8", "classic", "white"],
  ["Gold", "Crystalline", "8", "classic", "rose"],
  ["Gold", "Crystalline", "8", "white", "yellow"],
  ["Gold", "Crystalline", "8", "white", "white"],
  ["Gold", "Crystalline", "8", "white", "rose"],
  ["Gold", "Crystalline", "8", "black", "yellow"],
  ["Gold", "Crystalline", "8", "black", "white"],
  ["Gold", "Crystalline", "8", "black", "rose"],
  ["Gold", "Vertical Cuts", "6", "classic", "yellow"],
  ["Gold", "Vertical Cuts", "6", "classic", "white"],
  ["Gold", "Vertical Cuts", "6", "classic", "rose"],
  ["Gold", "Vertical Cuts", "6", "white", "yellow"],
  ["Gold", "Vertical Cuts", "6", "white", "white"],
  ["Gold", "Vertical Cuts", "6", "white", "rose"],
  ["Gold", "Vertical Cuts", "6", "black", "yellow"],
  ["Gold", "Vertical Cuts", "6", "black", "white"],
  ["Gold", "Vertical Cuts", "6", "black", "rose"],
  ["Gold", "Vertical Cuts", "8", "classic", "yellow"],
  ["Gold", "Vertical Cuts", "8", "classic", "white"],
  ["Gold", "Vertical Cuts", "8", "classic", "rose"],
  ["Gold", "Vertical Cuts", "8", "white", "yellow"],
  ["Gold", "Vertical Cuts", "8", "white", "white"],
  ["Gold", "Vertical Cuts", "8", "white", "rose"],
  ["Gold", "Vertical Cuts", "8", "black", "yellow"],
  ["Gold", "Vertical Cuts", "8", "black", "white"],
  ["Gold", "Vertical Cuts", "8", "black", "rose"],
  ["Gold", "Serrated Vertical Cuts", "6", "classic", "yellow"],
  ["Gold", "Serrated Vertical Cuts", "6", "classic", "white"],
  ["Gold", "Serrated Vertical Cuts", "6", "classic", "rose"],
  ["Gold", "Serrated Vertical Cuts", "6", "white", "yellow"],
  ["Gold", "Serrated Vertical Cuts", "6", "white", "white"],
  ["Gold", "Serrated Vertical Cuts", "6", "white", "rose"],
  ["Gold", "Serrated Vertical Cuts", "6", "black", "yellow"],
  ["Gold", "Serrated Vertical Cuts", "6", "black", "white"],
  ["Gold", "Serrated Vertical Cuts", "6", "black", "rose"],
  ["Gold", "Serrated Vertical Cuts", "8", "classic", "yellow"],
  ["Gold", "Serrated Vertical Cuts", "8", "classic", "white"],
  ["Gold", "Serrated Vertical Cuts", "8", "classic", "rose"],
  ["Gold", "Serrated Vertical Cuts", "8", "white", "yellow"],
  ["Gold", "Serrated Vertical Cuts", "8", "white", "white"],
  ["Gold", "Serrated Vertical Cuts", "8", "white", "rose"],
  ["Gold", "Serrated Vertical Cuts", "8", "black", "yellow"],
  ["Gold", "Serrated Vertical Cuts", "8", "black", "white"],
  ["Gold", "Serrated Vertical Cuts", "8", "black", "rose"],
  ["Gold", "Diagonal Cuts", "6", "classic", "yellow"],
  ["Gold", "Diagonal Cuts", "6", "classic", "white"],
  ["Gold", "Diagonal Cuts", "6", "classic", "rose"],
  ["Gold", "Diagonal Cuts", "6", "white", "yellow"],
  ["Gold", "Diagonal Cuts", "6", "white", "white"],
  ["Gold", "Diagonal Cuts", "6", "white", "rose"],
  ["Gold", "Diagonal Cuts", "6", "black", "yellow"],
  ["Gold", "Diagonal Cuts", "6", "black", "white"],
  ["Gold", "Diagonal Cuts", "6", "black", "rose"],
  ["Gold", "Diagonal Cuts", "8", "classic", "yellow"],
  ["Gold", "Diagonal Cuts", "8", "classic", "white"],
  ["Gold", "Diagonal Cuts", "8", "classic", "rose"],
  ["Gold", "Diagonal Cuts", "8", "white", "yellow"],
  ["Gold", "Diagonal Cuts", "8", "white", "white"],
  ["Gold", "Diagonal Cuts", "8", "white", "rose"],
  ["Gold", "Diagonal Cuts", "8", "black", "yellow"],
  ["Gold", "Diagonal Cuts", "8", "black", "white"],
  ["Gold", "Diagonal Cuts", "8", "black", "rose"],
  ["Gold", "Serrated Engraved", "6", "classic", "yellow"],
  ["Gold", "Serrated Engraved", "6", "classic", "white"],
  ["Gold", "Serrated Engraved", "6", "classic", "rose"],
  ["Gold", "Serrated Engraved", "6", "white", "yellow"],
  ["Gold", "Serrated Engraved", "6", "white", "white"],
  ["Gold", "Serrated Engraved", "6", "white", "rose"],
  ["Gold", "Serrated Engraved", "6", "black", "yellow"],
  ["Gold", "Serrated Engraved", "6", "black", "white"],
  ["Gold", "Serrated Engraved", "6", "black", "rose"],
  ["Gold", "Serrated Engraved", "8", "classic", "yellow"],
  ["Gold", "Serrated Engraved", "8", "classic", "white"],
  ["Gold", "Serrated Engraved", "8", "classic", "rose"],
  ["Gold", "Serrated Engraved", "8", "white", "yellow"],
  ["Gold", "Serrated Engraved", "8", "white", "white"],
  ["Gold", "Serrated Engraved", "8", "white", "rose"],
  ["Gold", "Serrated Engraved", "8", "black", "yellow"],
  ["Gold", "Serrated Engraved", "8", "black", "white"],
  ["Gold", "Serrated Engraved", "8", "black", "rose"],
  ["Gold", "Hammered", "6", "classic", "yellow"],
  ["Gold", "Hammered", "6", "classic", "white"],
  ["Gold", "Hammered", "6", "classic", "rose"],
  ["Gold", "Hammered", "6", "white", "yellow"],
  ["Gold", "Hammered", "6", "white", "white"],
  ["Gold", "Hammered", "6", "white", "rose"],
  ["Gold", "Hammered", "6", "black", "yellow"],
  ["Gold", "Hammered", "6", "black", "white"],
  ["Gold", "Hammered", "6", "black", "rose"],
  ["Gold", "Hammered", "8", "classic", "yellow"],
  ["Gold", "Hammered", "8", "classic", "white"],
  ["Gold", "Hammered", "8", "classic", "rose"],
  ["Gold", "Hammered", "8", "white", "yellow"],
  ["Gold", "Hammered", "8", "white", "white"],
  ["Gold", "Hammered", "8", "white", "rose"],
  ["Gold", "Hammered", "8", "black", "yellow"],
  ["Gold", "Hammered", "8", "black", "white"],
  ["Gold", "Hammered", "8", "black", "rose"],
  ["Gold", "Herringbone", "6", "classic", "yellow"],
  ["Gold", "Herringbone", "6", "classic", "white"],
  ["Gold", "Herringbone", "6", "classic", "rose"],
  ["Gold", "Herringbone", "6", "white", "yellow"],
  ["Gold", "Herringbone", "6", "white", "white"],
  ["Gold", "Herringbone", "6", "white", "rose"],
  ["Gold", "Herringbone", "6", "black", "yellow"],
  ["Gold", "Herringbone", "6", "black", "white"],
  ["Gold", "Herringbone", "6", "black", "rose"],
  ["Gold", "Herringbone", "8", "classic", "yellow"],
  ["Gold", "Herringbone", "8", "classic", "white"],
  ["Gold", "Herringbone", "8", "classic", "rose"],
  ["Gold", "Herringbone", "8", "white", "yellow"],
  ["Gold", "Herringbone", "8", "white", "white"],
  ["Gold", "Herringbone", "8", "white", "rose"],
  ["Gold", "Herringbone", "8", "black", "yellow"],
  ["Gold", "Herringbone", "8", "black", "white"],
  ["Gold", "Herringbone", "8", "black", "rose"],
  ["Gold", "Vertical Satin", "6", "classic", "yellow"],
  ["Gold", "Vertical Satin", "6", "classic", "white"],
  ["Gold", "Vertical Satin", "6", "classic", "rose"],
  ["Gold", "Vertical Satin", "6", "white", "yellow"],
  ["Gold", "Vertical Satin", "6", "white", "white"],
  ["Gold", "Vertical Satin", "6", "white", "rose"],
  ["Gold", "Vertical Satin", "6", "black", "yellow"],
  ["Gold", "Vertical Satin", "6", "black", "white"],
  ["Gold", "Vertical Satin", "6", "black", "rose"],
  ["Gold", "Vertical Satin", "8", "classic", "yellow"],
  ["Gold", "Vertical Satin", "8", "classic", "white"],
  ["Gold", "Vertical Satin", "8", "classic", "rose"],
  ["Gold", "Vertical Satin", "8", "white", "yellow"],
  ["Gold", "Vertical Satin", "8", "white", "white"],
  ["Gold", "Vertical Satin", "8", "white", "rose"],
  ["Gold", "Vertical Satin", "8", "black", "yellow"],
  ["Gold", "Vertical Satin", "8", "black", "white"],
  ["Gold", "Vertical Satin", "8", "black", "rose"],
  ["Gold", "Criss Cross", "6", "classic", "yellow"],
  ["Gold", "Criss Cross", "6", "classic", "white"],
  ["Gold", "Criss Cross", "6", "classic", "rose"],
  ["Gold", "Criss Cross", "6", "white", "yellow"],
  ["Gold", "Criss Cross", "6", "white", "white"],
  ["Gold", "Criss Cross", "6", "white", "rose"],
  ["Gold", "Criss Cross", "6", "black", "yellow"],
  ["Gold", "Criss Cross", "6", "black", "white"],
  ["Gold", "Criss Cross", "6", "black", "rose"],
  ["Gold", "Criss Cross", "8", "classic", "yellow"],
  ["Gold", "Criss Cross", "8", "classic", "white"],
  ["Gold", "Criss Cross", "8", "classic", "rose"],
  ["Gold", "Criss Cross", "8", "white", "yellow"],
  ["Gold", "Criss Cross", "8", "white", "white"],
  ["Gold", "Criss Cross", "8", "white", "rose"],
  ["Gold", "Criss Cross", "8", "black", "yellow"],
  ["Gold", "Criss Cross", "8", "black", "white"],
  ["Gold", "Criss Cross", "8", "black", "rose"],
  ["Gold", "Religious", "8", "classic", "yellow"],
  ["Gold", "Religious", "8", "classic", "white"],
  ["Gold", "Religious", "8", "classic", "rose"],
  ["Gold", "Religious", "8", "white", "yellow"],
  ["Gold", "Religious", "8", "white", "white"],
  ["Gold", "Religious", "8", "white", "rose"],
  ["Gold", "Religious", "8", "black", "yellow"],
  ["Gold", "Religious", "8", "black", "white"],
  ["Gold", "Religious", "8", "black", "rose"],
  ["Gold", "Rhombus", "6", "white", "yellow"],
  ["Gold", "Rhombus", "8", "black", "yellow"],
  ["Gold", "3D Wave", "6", "white", "yellow"],
  ["Gold", "3D Wave", "8", "white", "rose"],
  ["Gold", "Oblong Infinity", "6", "white", "yellow"],
  ["Gold", "Oblong Infinity", "8", "black", "white"],
  ["Gold", "StarX", "6", "white", "yellow"],
  ["Gold", "StarX", "8", "white", "rose"],
  ["Gold", "Vertical Geo", "6", "white", "yellow"],
  ["Gold", "Vertical Geo", "8", "black", "rose"],
  ["Gold", "Beveled Prism", "6", "white", "yellow"],
  ["Gold", "Beveled Prism", "8", "black", "yellow"],
  ["Gold", "Cubed", "6", "black", "rose"],
  ["Gold", "Cubed", "8", "white", "yellow"],
  ["Gold", "Diagonal Brick", "6", "white", "rose"],
  ["Gold", "Diagonal Brick", "8", "black", "white"],
  ["Titanium", "Wave", "6", "classic", ""],
  ["Titanium", "Wave", "6", "white", ""],
  ["Titanium", "Wave", "6", "black", ""],
  ["Titanium", "Wave", "8", "classic", ""],
  ["Titanium", "Wave", "8", "white", ""],
  ["Titanium", "Wave", "8", "black", ""],
  ["Titanium", "Chevron", "6", "classic", ""],
  ["Titanium", "Chevron", "6", "white", ""],
  ["Titanium", "Chevron", "6", "black", ""],
  ["Titanium", "Chevron", "8", "classic", ""],
  ["Titanium", "Chevron", "8", "white", ""],
  ["Titanium", "Chevron", "8", "black", ""],
  ["Titanium", "Tire Tred", "6", "classic", ""],
  ["Titanium", "Tire Tred", "6", "white", ""],
  ["Titanium", "Tire Tred", "6", "black", ""],
  ["Titanium", "Tire Tred", "8", "classic", ""],
  ["Titanium", "Tire Tred", "8", "white", ""],
  ["Titanium", "Tire Tred", "8", "black", ""],
  ["Wood", "Acacia", "6", "classic", ""],
  ["Wood", "Acacia", "6", "white", ""],
  ["Wood", "Acacia", "6", "black", ""],
  ["Wood", "Acacia", "8", "classic", ""],
  ["Wood", "Acacia", "8", "white", ""],
  ["Wood", "Acacia", "8", "black", ""],
  ["Wood", "Cherry Wood", "6", "black", ""],
  ["Wood", "Cherry Wood", "8", "white", ""],
  ["Wood", "Maple Wood", "6", "white", ""],
  ["Wood", "Maple Wood", "8", "black", ""],
  ["Wood", "Walnut Wood", "6", "white", ""],
  ["Wood", "Walnut Wood", "8", "white", ""],
  ["Meteorite", "Muonionalusta", "8", "classic", ""],
  ["Meteorite", "Muonionalusta", "8", "white", ""],
  ["Meteorite", "Muonionalusta", "8", "black", ""],
  ["Carbon fiber", "Forged", "6", "classic", ""],
  ["Carbon fiber", "Forged", "6", "white", ""],
  ["Carbon fiber", "Forged", "6", "black", ""],
  ["Carbon fiber", "Forged", "8", "classic", ""],
  ["Carbon fiber", "Forged", "8", "white", ""],
  ["Carbon fiber", "Forged", "8", "black", ""],
  ["Carbon fiber", "Twill", "6", "classic", ""],
  ["Carbon fiber", "Twill", "6", "white", ""],
  ["Carbon fiber", "Twill", "6", "black", ""],
  ["Carbon fiber", "Twill", "8", "classic", ""],
  ["Carbon fiber", "Twill", "8", "white", ""],
  ["Carbon fiber", "Twill", "8", "black", ""],
  ["Carbon fiber", "Titanium Center Line", "6", "white", ""],
  ["Carbon fiber", "Titanium Center Line", "8", "black", ""],
  ["Carbon fiber", "Titanium Off Center Line", "6", "classic", ""],
  ["Carbon fiber", "Titanium Off Center Line", "8", "black", ""],
  ["Carbon fiber", "Flat Insert", "6", "black", ""],
  ["Carbon fiber", "Flat Insert", "8", "rose", ""],
  ["Carbon fiber", "Cherry Wood", "8", "black", ""],
  ["Carbon fiber", "Maple Wood", "8", "white", ""],
  ["Diamond", "Black Diamonds", "8", "classic", "yellow"],
  ["Diamond", "Black Diamonds", "8", "classic", "white"],
  ["Diamond", "Black Diamonds", "8", "classic", "rose"],
  ["Diamond", "Black Diamonds", "8", "white", "yellow"],
  ["Diamond", "Black Diamonds", "8", "white", "white"],
  ["Diamond", "Black Diamonds", "8", "white", "rose"],
  ["Diamond", "Black Diamonds", "8", "black", "yellow"],
  ["Diamond", "Black Diamonds", "8", "black", "white"],
  ["Diamond", "Black Diamonds", "8", "black", "rose"],
  ["Diamond", "White Diamonds", "8", "classic", "yellow"],
  ["Diamond", "White Diamonds", "8", "classic", "white"],
  ["Diamond", "White Diamonds", "8", "classic", "rose"],
  ["Diamond", "White Diamonds", "8", "white", "yellow"],
  ["Diamond", "White Diamonds", "8", "white", "white"],
  ["Diamond", "White Diamonds", "8", "white", "rose"],
  ["Diamond", "White Diamonds", "8", "black", "yellow"],
  ["Diamond", "White Diamonds", "8", "black", "white"],
  ["Diamond", "White Diamonds", "8", "black", "rose"],
];
